import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BrochureModal = ({ open, onClose, courseTitle, vendorSlug, vendorName }) => {
    const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", jobTitle: "" });
    const [loading, setLoading] = useState(false);
    if (!open) return null;
    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!form.name.trim() || !form.email.trim()) {
            toast.error("Please share your name and business email.");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(`${API}/brochure-request`, {
                ...form,
                course: courseTitle,
                vendor: vendorName,
                vendor_slug: vendorSlug,
            });
            const dl = res.data.download_url || `/api/brochure/${vendorSlug}.pdf`;
            const qs = new URLSearchParams();
            if (courseTitle) qs.set("course", courseTitle);
            if (vendorName) qs.set("vendor", vendorName);
            const sep = dl.includes("?") ? "&" : "?";
            const url = `${process.env.REACT_APP_BACKEND_URL}${dl}${qs.toString() ? sep + qs.toString() : ""}`;
            const a = document.createElement("a");
            a.href = url;
            a.download = `SpringXE-${vendorSlug}-brochure.pdf`;
            document.body.appendChild(a); a.click(); a.remove();
            toast.success("Brochure is downloading. Our team will reach out shortly.");
            setForm({ name: "", email: "", phone: "", company: "", jobTitle: "" });
            onClose();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Unable to prepare your brochure.");
        } finally { setLoading(false); }
    };
    return (
        <div data-testid="brochure-modal" className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-up" onClick={onClose}>
            <form onClick={(e) => e.stopPropagation()} onSubmit={onSubmit} className="w-full max-w-lg sxe-glass rounded-2xl border border-[#C266FF]/30 p-6 md:p-8 relative">
                <button type="button" onClick={onClose} aria-label="Close" data-testid="brochure-modal-close" className="absolute top-4 right-4 w-9 h-9 rounded-full border border-white/10 text-white hover:border-[#C266FF]/50 flex items-center justify-center"><X className="w-4 h-4" /></button>
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#A100FF] to-[#7B00CC] flex items-center justify-center"><Download className="w-6 h-6 text-white" /></div>
                <h3 className="font-display text-white text-2xl md:text-3xl font-medium tracking-tight mt-5">Download course brochure</h3>
                {courseTitle && <p className="text-[#E9CCFF] text-sm mt-1">{courseTitle}</p>}
                <p className="text-[#B0A3C4] text-sm mt-2">Share a few details and we&apos;ll open the brochure instantly, plus keep you posted on cohort dates.</p>
                <div className="grid md:grid-cols-2 gap-3 mt-6">
                    <div>
                        <label className="text-[10px] uppercase tracking-widest text-[#75668C] font-display">Full Name*</label>
                        <input data-testid="brochure-input-name" name="name" value={form.name} onChange={onChange} className="sxe-input mt-1" placeholder="Your name" required />
                    </div>
                    <div>
                        <label className="text-[10px] uppercase tracking-widest text-[#75668C] font-display">Business Email*</label>
                        <input data-testid="brochure-input-email" name="email" type="email" value={form.email} onChange={onChange} className="sxe-input mt-1" placeholder="you@company.com" required />
                    </div>
                    <div>
                        <label className="text-[10px] uppercase tracking-widest text-[#75668C] font-display">Phone Number</label>
                        <input data-testid="brochure-input-phone" name="phone" value={form.phone} onChange={onChange} className="sxe-input mt-1" placeholder="+91 ..." />
                    </div>
                    <div>
                        <label className="text-[10px] uppercase tracking-widest text-[#75668C] font-display">Company Name</label>
                        <input data-testid="brochure-input-company" name="company" value={form.company} onChange={onChange} className="sxe-input mt-1" placeholder="Company name" />
                    </div>
                    <div className="md:col-span-2">
                        <label className="text-[10px] uppercase tracking-widest text-[#75668C] font-display">Job Title</label>
                        <input data-testid="brochure-input-jobtitle" name="jobTitle" value={form.jobTitle} onChange={onChange} className="sxe-input mt-1" placeholder="e.g. Head of L&amp;D" />
                    </div>
                </div>
                <button type="submit" disabled={loading} data-testid="brochure-submit-btn" className="btn-primary w-full mt-6 disabled:opacity-60">
                    {loading ? "Preparing your brochure..." : (<>Download Brochure <Download className="w-4 h-4" /></>)}
                </button>
            </form>
        </div>
    );
};

export default BrochureModal;
